<template>
  <div>
    <GoBack />
    <section class="destinations">
      <h1>
        {{ range.name }}
      </h1>
      <div class="destination-details">
        <img :src="img" :alt="range.name" />
        <div id="range-desc" v-html="range.description"></div>
        
        <div v-if="range.barrierFree" id="range-barrier-free">
          <v-icon>mdi-wheelchair-accessibility</v-icon>
          <span>Bezbariérové</span>
        </div>
        <a target="_blank" :href="'https://mapy.cz/?q=' + range.lat + 'N,' + range.lng + 'E'">
          <div id="range-gps">{{ range.lat }}N, {{ range.lng }}E</div>
        </a>
      </div>
    </section>
    <section class="experiences">
      <div class="cards" id="experience"></div>
      <router-view :key="$route.path" />
    </section>

    <!-- START -->

    <v-text-field label="Zadejte kód voucheru" name="voucherCode" style="width: 50%; margin: 0 auto"
      v-model="voucherCode">
      <v-icon slot="append-outer" @click="resetVoucher">
        mdi-close-circle
      </v-icon>
    </v-text-field>

    <div id="voucher-error">{{ vouchError }}</div>

    <div class="available-events">
      <h4>Dostupné termíny jsou označeny oranžově</h4>
    </div>

    <Calendar language="cs" :class="calendarClass" :min-date="new Date()" :data-source="activeDates"
      render-style="custom" :custom-data-source-renderer="dayRenderer" round-range-limits="true"
      @click-day="toggleDate">
    </Calendar>

    <!-- END -->
    <v-app id="inspire" :class="calendarClass2">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn outlined class="mr-4" color="grey darken-2" @click="this.yearcalendar_show">Zpátky k vyběru měsiců
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small> mdi-chevron-right </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right> mdi-menu-down </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Den</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Týden</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Měsíc</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet>
            <v-calendar locale="cs" ref="calendar" v-model="focus" color="primary" :events="calendar_events"
              :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
              @click:date="viewDay" first-time="06:00" interval-count="18" :event-margin-bottom="2"
              interval-height="40">
            </v-calendar>
            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
              <v-card color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <router-link :to="{
                    name: 'experienceDetails',
                    params: { experienceSlug: selectedEvent.details },
                    hash: '#experience'
                  }">
                    <v-btn color="#ff6319" dark class="mb-2" @click="selectedOpen = false">
                      Vybrat
                    </v-btn>
                  </router-link>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="secondary" @click="selectedOpen = false">
                    Zavřít
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </v-app>

    <!-- END -->
  </div>
</template>
<script>
import GoBack from "@/components/GoBack";
import funcs from "@/ranges.js";
import Calendar from "v-year-calendar";
import "v-year-calendar/locales/v-year-calendar.cs";

export default {
  components: {
    GoBack,
    Calendar
  },

  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      voucherCode: this.$root.voucher,
      year: new Date().getFullYear(),
      activeDates: [],
      calendarClass: "calendar", //year calendar
      calendarClass2: "hidden", //month calendar
      showYearSelector: true,
      id: "",
      vouchDisabled: false,
      ranges: [],
      range: {},
      vouchLabel: "Zadejte kód voucheru",
      terms: [],
      term: [],
      formated_terms: {},
      focus: "",
      prefixes: {},
      type: "day",
      images: [],
      img: "loading.gif",
      typeToLabel: {
        month: "Měsíc",
        week: "Týden",
        day: "Den"
      },
      vouchError: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      calendar_events: []
    };
  },

  methods: {
    checkVoucher() {
      const regex = /^[a-zA-Z0-9]{3}-.*/;
      const voucher = this.$root.voucher;

      this.vouchError = "";
      this.$root.invalidVoucher = false;
      this.calendarClass2 = "hidden";

      if (/^[a-zA-Z0-9]{8}$/.test(voucher)) {
        this.vouchError =
          "Vložili jste kód pro sdílení namísto reálneho kódu voucheru. Správny kód voucheru je ve tvaru XXX-YYYYY - například QAD-COSI9";
        this.$root.invalidVoucher = true;
        return;
      }

      if (regex.test(voucher)) {
        const prefix = voucher.substring(0, 3);
        if (this.prefixes[prefix] != null) {
          let result = funcs.calendarTerms(
            this.term,
            this.prefixes[prefix],
            "Home"
          );
          this.activeDates = result["activeDates"];
          this.calendar_events = result["calendarTerms"];
        } else {
          this.vouchError = "Zadný voucher není v systému.";
          this.$root.invalidVoucher = true;
        }
      }
    },
    toggleDate(dateInfo) {
      //toggles date
      this.focus = dateInfo.date;
      this.calendarClass = "hidden"; //hides year calendar
      this.calendarClass2 = ""; //shows month calendar

      setTimeout(() => {
        $("html, body").animate(
          { scrollTop: $("#inspire").offset().top - 100 },
          100
        );
      }, 100);
      // push history
      this.$router.push({
        hash: "#event-dates",
        params: {
          date: dateInfo.date
        }
      });

      window.addEventListener(
        "popstate",
        () => {
          this.calendarClass = "calendar";
          this.calendarClass2 = "hidden";
        },
        {
          once: true
        }
      );
    },

    dayRenderer(elt, currentDate, events) {
      elt.classList.add(events[0].active ? 'date-active' : 'date-inactive');
    },

    yearcalendar_show() {
      this.calendarClass = "calendar";
      this.calendarClass2 = "hidden";
      this.$router.go(-1);

      window.removeEventListener(
        "popstate",
        () => {
          this.calendarClass = "calendar";
          this.calendarClass2 = "hidden";
        },
        {
          once: true
        }
      );
    },

    setValues() {
      if (this.$root.loading != true) {
        let cal_e = [];
        this.ranges = this.$root.ranges;
        this.terms = this.$root.terms;
        this.prefixes = this.$root.prefixes;
        this.formated_terms = this.$root.formated_terms;
        this.markers = this.$root.markers;
        cal_e = this.$root.calendarTerms;
        for (let i = 0; i < cal_e.length; i++) {
          if (cal_e[i].slug == this.id) {
            this.calendar_events.push(cal_e[i]);
          }
        }

        this.activeDates = this.$root.activeDates;
      }
    },

    resetVoucher() {
      this.voucherCode = "";
    },

    render() {
      if (this.$root.loading != true) {
        let find = this.ranges.find(function (element) {
          return element.id == this.id;
        }, this);

        this.range = find;
        this.img = this.range.imageSrc;
        this.term = this.formated_terms[this.range.id];

        let result = funcs.calendarTerms(this.term);
        if (result != null) this.activeDates = result["activeDates"];
        else this.activeDates = [];

        if (this.$root.voucher != null && this.$root.invalidVoucher == false) {
          let prefix = this.$root.voucher.substring(0, 3);
          let result = funcs.calendarTerms(this.term, this.prefixes[prefix]);
          if (result != null) {
            this.activeDates = result["activeDates"];
            this.calendar_events = result["calendarTerms"];
          } else {
            this.activeDates = [];
            this.calendar_events = [];
          }

          this.vouchLabel = "Voucher: " + this.$root.voucher;

          this.vouchDisabled = true;
        } else if (this.$root.invalidVoucher == true) {
          this.vouchLabel = "Voucher: " + this.$root.voucher;
          this.vouchDisabled = true;
        }
      }
    },

    viewDay({ date }) {
      this.focus = date;

      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      if (event.spots === 0) {
        return;
      }

      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    }
  },

  mounted() {
    this.id = this.slug;
    this.setValues();
    this.render();
    this.checkVoucher();
  },
  watch: {
    "$root.loading": function (val) {
      if (val == false) {
        this.setValues();
        this.render();
      }
    },
    voucherCode() {
      this.$root.voucher = this.voucherCode;
      this.checkVoucher();
    }
  }
};
</script>

<style scoped>
#inspire {
  max-width: 1200px;
  margin: 0 auto;
}

.available-events h4 {
  font-weight: bold;
  color: #ff6319;
}

.v-input--is-disabled .v-icon {
  pointer-events: auto;
}

img {
  max-width: 600px;
  height: auto;
  width: 100%;
  max-height: 400px;
}

.experiences {
  padding: 40px 0;
}

.destination-details {
  width: 50%;
  margin: auto;
  justify-content: space-between;
}

p {
  margin: 0 40px;
  font-size: 20px;
  text-align: left;
}

.cards img {
  max-height: 200px;
}

.card {
  padding: 0 20px;
  position: relative;
}

.card__text {
  transform: translate(-50%, -50%);
  color: black;
  font-size: 25px;
  font-weight: bold;
  text-decoration: none;
}

input#voucher {
  font-size: 16px;
}

#voucher-wrapper {
  margin: 40px;
}
</style>

<style>
.v-calendar .v-event-summary {
  visibility: collapse !important;
}

.v-calendar .v-event-summary strong {
  visibility: visible !important;
}

.calendar {
  overflow-x: auto !important;
  max-width: 1200px;
  margin: 0 auto;
}

.calendar .calendar-header {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 65px;
  background-color: #fff;
  font-size: 24px;
  -webkit-box-flex: 100%;
  -ms-flex: 100%;
  flex: 100%;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.calendar .calendar-header table {
  margin: 0;
}

.calendar .calendar-header table th {
  vertical-align: middle;
}

.calendar .calendar-header .year-title {
  box-shadow: inset 0 -3px #4792bd;
}

.calendar .calendar-header .year-neighbor,
.calendar .calendar-header .year-neighbor2 {
  box-shadow: none;
}

.calendar .months-container {
  flex-wrap: wrap;
  display: flex !important;
  padding: 15px;
}

.calendar .months-container .month-container {
  padding: 8px !important;
  flex: 25%;
  width: auto !important;
  float: none !important;
  height: auto !important;
}

@media (max-width: 450px) {
  .calendar .months-container .month-container {
    flex: 100%;
  }
}

@media (max-width: 768px) {
  .calendar .months-container .month-container {
    flex: 50%;
  }
}

@media (max-width: 992px) {
  .calendar .months-container .month-container {
    flex: 33.3%;
  }
}

.calendar .months-container .month-container .month {
  background-color: #fff;
  min-height: 295px;
  text-align: center;
  color: rgba(53, 60, 70, 0.8);
  border-radius: 2px;
  min-width: 0;
  position: relative;
  text-decoration: none;
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  -webkit-box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%),
    0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 1px -1pxrgba (0, 0, 0, 0.2), 0 1px 1px 0rgba (0, 0, 0, 0.14),
    0 1px 3px 0rgba (0, 0, 0, 0.12);
}

.calendar table.month th.month-title {
  font-size: 18px;
  padding-bottom: 5px;
  font-weight: 700;
  border-bottom: 1px solid hsla(0, 0%, 76.9%, 0.3);
  font-size: 18px;
  height: 50px;
  margin-bottom: 12px;
  vertical-align: middle;
}

.calendar table.month th.day-header {
  padding-top: 15px;
}

.calendar table td,
.calendar table th {
  width: 70px;
}

.calendar table.month td.day:not(.disabled) .day-content {
  color: #5db3d4;
}

.calendar .date-active {
  background-color: #ff6319;
  color: white !important;
}

.calendar .date-inactive {
  background-color: #dddddd;
}

.v-event-timed-container .v-event-timed {
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}
</style>

<style>
.call--active {
  background-color: #0aa;
  color: #fff;
}

.call--active:hover {
  background-color: #fff;
  color: #0aa;
}
</style>
